import React from 'react';
import { PdfButton } from './PdfButton';

interface Props {
  owner: any;
}

export const PdfLoader = (props: Props) => {
  const [show, setShow] = React.useState(false);

  return (
    <React.Fragment>
      {show || (
        <button className='btn btn-dark' onClick={() => setShow(true)}>
          Generate Owner Letter
        </button>
      )}
      {show && <PdfButton owner={props.owner} />}
    </React.Fragment>
  );
};
